import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'
import { distinctUntilChanged, filter, map, shareReplay, startWith } from 'rxjs'
import { PresenterConstants } from '../presenter.constants'
import { AsyncPipe } from '@angular/common'
import { PRESENTER_CONTEXT } from 'libs/gb-dashboard/presenter/utils/src/lib/gb-presenter-context/presenter-context.token'

@Component({
  selector: 'gb-presenter-widget-placeholder',
  imports: [AsyncPipe],
  templateUrl: './gb-presenter-widget-placeholder.component.html',
  styleUrl: './gb-presenter-widget-placeholder.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GbPresenterWidgetPlaceholderComponent {
  private router = inject(Router)
  private readonly presenterContext = inject(PRESENTER_CONTEXT)

  isLaunchMode$ = this.router.events.pipe(
    filter((event): event is NavigationEnd => event instanceof NavigationEnd),
    startWith(null),
    map(
      () => this.router.url.includes(PresenterConstants.PRESENTER) && this.router.url.includes(PresenterConstants.VIEW),
    ),
    distinctUntilChanged(),
    shareReplay({ bufferSize: 1, refCount: true }),
  )

  get isTemplateMode() {
    return this.presenterContext.mode === 'template'
  }
}
